import React from 'react';
import Icon from '../../../components/AppIcon';

const UniversityMetrics = () => {
  const universityData = {
    name: "Universidad Complutense Madrid",
    totalStudents: 86000,
    activeUsers: 12500,
    userRanking: 8,
    totalFoodRescued: 2850,
    totalWaterSaved: 42750,
    totalCO2Avoided: 1995,
    userContribution: {
      food: 34,
      water: 510,
      co2: 23.8
    }
  };

  const contributionPercentages = {
    food: (universityData?.userContribution?.food / universityData?.totalFoodRescued * 100)?.toFixed(2),
    water: (universityData?.userContribution?.water / universityData?.totalWaterSaved * 100)?.toFixed(2),
    co2: (universityData?.userContribution?.co2 / universityData?.totalCO2Avoided * 100)?.toFixed(2)
  };

  const topContributors = [
  {
    rank: 1,
    name: "María González",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1beb9fc75-1762273370028.png",
    avatarAlt: "Professional headshot of young Hispanic woman with long dark hair and bright smile",
    foodRescued: 89,
    faculty: "Ciencias Ambientales"
  },
  {
    rank: 2,
    name: "Carlos Ruiz",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1285ffce5-1762273411616.png",
    avatarAlt: "Professional headshot of young man with short brown hair and friendly expression",
    foodRescued: 76,
    faculty: "Ingeniería"
  },
  {
    rank: 3,
    name: "Ana Martín",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1274dd504-1762275023732.png",
    avatarAlt: "Professional headshot of young woman with blonde hair and professional attire",
    foodRescued: 68,
    faculty: "Medicina"
  }];


  const facultyRankings = [
  { name: "Ciencias Ambientales", foodRescued: 485, students: 3200, avgPerStudent: 0.15 },
  { name: "Ingeniería", foodRescued: 420, students: 8500, avgPerStudent: 0.05 },
  { name: "Medicina", foodRescued: 380, students: 6200, avgPerStudent: 0.06 },
  { name: "Derecho", foodRescued: 295, students: 4800, avgPerStudent: 0.06 },
  { name: "Economía", foodRescued: 270, students: 5100, avgPerStudent: 0.05 }];


  return (
    <div className="space-y-6">
      {/* University Overview */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
            <Icon name="GraduationCap" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg text-foreground">
              {universityData?.name}
            </h3>
            <p className="text-sm text-muted-foreground">
              Impacto colectivo del campus
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-bold text-primary mb-1">
              {universityData?.activeUsers?.toLocaleString()}
            </div>
            <div className="text-xs text-muted-foreground">Usuarios Activos</div>
          </div>
          
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-bold text-success mb-1">
              {universityData?.totalFoodRescued}kg
            </div>
            <div className="text-xs text-muted-foreground">Comida Rescatada</div>
          </div>
          
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-bold text-primary mb-1">
              {universityData?.totalWaterSaved?.toLocaleString()}L
            </div>
            <div className="text-xs text-muted-foreground">Agua Ahorrada</div>
          </div>
          
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-bold text-accent mb-1">
              {universityData?.totalCO2Avoided}kg
            </div>
            <div className="text-xs text-muted-foreground">CO₂ Evitado</div>
          </div>
        </div>

        {/* User Contribution */}
        <div className="bg-gradient-to-r from-primary/5 to-success/5 rounded-lg p-4 border border-primary/20">
          <h4 className="font-medium text-foreground mb-3 flex items-center">
            <Icon name="User" size={16} className="mr-2" />
            Tu Contribución al Campus
          </h4>
          
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-lg font-bold text-success">
                {contributionPercentages?.food}%
              </div>
              <div className="text-xs text-muted-foreground">de la comida rescatada</div>
            </div>
            <div>
              <div className="text-lg font-bold text-primary">
                {contributionPercentages?.water}%
              </div>
              <div className="text-xs text-muted-foreground">del agua ahorrada</div>
            </div>
            <div>
              <div className="text-lg font-bold text-accent">
                {contributionPercentages?.co2}%
              </div>
              <div className="text-xs text-muted-foreground">del CO₂ evitado</div>
            </div>
          </div>
        </div>
      </div>
      {/* Top Contributors */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="font-heading font-semibold text-lg text-foreground">
            Top Rescatadores del Campus
          </h3>
          <div className="flex items-center space-x-2 text-warning">
            <Icon name="Trophy" size={16} />
            <span className="text-sm font-medium">Tu posición: #{universityData?.userRanking}</span>
          </div>
        </div>

        <div className="space-y-3">
          {topContributors?.map((contributor) =>
          <div key={contributor?.rank} className="flex items-center space-x-4 p-3 bg-muted/30 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
              contributor?.rank === 1 ? 'bg-warning text-warning-foreground' :
              contributor?.rank === 2 ? 'bg-muted text-foreground' : 'bg-secondary text-secondary-foreground'}`
              }>
                  {contributor?.rank}
                </div>
                
                <img
                src={contributor?.avatar}
                alt={contributor?.avatarAlt}
                className="w-10 h-10 rounded-full object-cover" />

              </div>
              
              <div className="flex-1">
                <div className="font-medium text-foreground">{contributor?.name}</div>
                <div className="text-xs text-muted-foreground">{contributor?.faculty}</div>
              </div>
              
              <div className="text-right">
                <div className="font-bold text-success">{contributor?.foodRescued}kg</div>
                <div className="text-xs text-muted-foreground">rescatados</div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Faculty Rankings */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="font-heading font-semibold text-lg text-foreground mb-6">
          Ranking por Facultades
        </h3>

        <div className="space-y-3">
          {facultyRankings?.map((faculty, index) =>
          <div key={faculty?.name} className="flex items-center space-x-4 p-3 bg-muted/30 rounded-lg">
              <div className="w-8 h-8 bg-primary/20 rounded-full flex items-center justify-center">
                <span className="text-sm font-bold text-primary">{index + 1}</span>
              </div>
              
              <div className="flex-1">
                <div className="font-medium text-foreground">{faculty?.name}</div>
                <div className="text-xs text-muted-foreground">
                  {faculty?.students?.toLocaleString()} estudiantes
                </div>
              </div>
              
              <div className="text-right">
                <div className="font-bold text-success">{faculty?.foodRescued}kg</div>
                <div className="text-xs text-muted-foreground">
                  {(faculty?.avgPerStudent * 1000)?.toFixed(0)}g/estudiante
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-4 p-4 bg-primary/5 rounded-lg border border-primary/20">
          <div className="flex items-center space-x-2 text-primary">
            <Icon name="Info" size={16} />
            <span className="text-sm font-medium">
              Tu facultad (Ciencias Ambientales) lidera el ranking con el mayor impacto per cápita
            </span>
          </div>
        </div>
      </div>
    </div>);

};

export default UniversityMetrics;